import { OnInit } from '@angular/core';
import { isNullOrUndefined } from 'util';
var AutoPlanOperationsComponent = /** @class */ (function () {
    function AutoPlanOperationsComponent() {
        this.policyData = {
            policyNumber: ''
        };
    }
    AutoPlanOperationsComponent.prototype.ngOnInit = function () { };
    AutoPlanOperationsComponent.prototype.openModal = function (operation) {
        this.policyData.policyNumber = operation.policyNumberComplete;
        this.modalDescargas.open();
    };
    AutoPlanOperationsComponent.prototype.getName = function (item) {
        if (isNullOrUndefined(item.firstName)) {
            return item.companyname;
        }
        else {
            return item.firstName + " " + item.lastName;
        }
    };
    return AutoPlanOperationsComponent;
}());
export { AutoPlanOperationsComponent };
